// status
export const PLAYING = 'PLAYING'
export const PAUSING = 'PAUSING'
export const STOPPED = 'STOPPED'


// WEBPACK FOOTER //
// ./src/constants/gameStatus.js